<i18n
  src="@/locales/views/agro_exporter/quality_control/container/containers_inspect_graphs.yml"
  lang="yaml"
></i18n>
<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    name="ae_quality_control_container_list_containers_path"
    :params="{
      agro_exporter_process_id: agro_exporter_process_id,
    }"
  ></go-back-link>
  <bread-crumbs
    :labels="[
      module_name,
      agro_exporter_process?.name,
      quality_template?.name,
    ]"
  ></bread-crumbs>
  <div v-if="containers.length > 0">
    <div class="page-title">Porcentaje de calidad</div>
    <percent-graph
      v-if="containers"
      :containers="containers"
      :quality_attributes="quality_attributes"
    />
    <!-- <div
      v-for="quality_attribute in quality_attributes"
      :key="quality_attribute.id"
    >
      <div class="page-title mt-8">
        {{ quality_attribute.crop_attribute.name }}
      </div>
      <attribute-graph
        :containers="containers"
        :quality_attribute="quality_attribute"
      />
    </div> -->
  </div>
  <div class="panel p-2" v-else>
    <p>No hay registros de este tipo de inspecciones</p>
  </div>
  <div></div>
</template>

<script>
import Requester from "@/views/agro_exporter/requesters/quality_control/container/containers_inspect_graphs.js";
import PercentGraph from "@/components/views/agro_exporter/quality_control/container/containers_inspect_graphs/PercentGraph.vue";
// import AttributeGraph from "@/components/views/agro_exporter/quality_control/container/containers_inspect_graphs/AttributeGraph.vue";

import BreadCrumbs from "@/components/views/layout/BreadCrumbs.vue";
export default {
  components: { BreadCrumbs, PercentGraph },
  props: {
    agro_exporter_id: { required: true },
    agro_exporter_process_id: {
      required: true,
    },
    exporter_process_quality_template_id: {
      required: true,
    },
  },
  data: function () {
    return {
      agro_exporter_process: null,
      quality_template: null,
      containers: [],
      quality_attributes: null,
    };
  },
  methods: {
    fetchAgroExporterProcess: async function () {
      let response = await Requester.fetchAgroExporterProcess(
        this.agro_exporter_process_id
      );
      this.agro_exporter_process = response.data;
    },
    fetchExporterQualityTemplate: async function () {
      let response = await Requester.fetchExporterQualityTemplate(
        this.agro_exporter_process_id,
        this.exporter_process_quality_template_id
      );
      this.quality_template = response.data;
    },
    fetchContainers: async function () {
      let response = await Requester.fetchContainers(
        this.agro_exporter_process_id,
        this.exporter_process_quality_template_id
      );
      this.containers = response.data.containers;
      this.quality_attributes =
        response.data.quality_attributes;
    },
  },
  created: function () {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          agro_exporter_id: this.agro_exporter_id,
        },
      }).then(() => {
        this.fetchAgroExporterProcess();
        this.fetchExporterQualityTemplate();
        this.fetchContainers();
      })
    );
  },
};
</script>

<style>
</style>
